
const m = window.require("discourse/helpers/discourse-tag");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
